<style lang="scss" scoped>

    #popup-container{
        position:fixed;
        top:0;
        left:0;
        width:100vw;
        height:100%;
        z-index:99999;
        pointer-events: none;
        overflow: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 0px;
        padding-bottom: 0px;
        overflow-y: scroll;

        @media (max-width: 767px) {
            display: block;
            padding-bottom:0px;
        }

        .invalid-feedback{
            display: none;
            position: relative;
            top: -1px;

            &.privacy {
                //top: calc(100% + 5px);
            }

        }

        &.appear{
            pointer-events: all;
            transition: all 600ms;

            .background-obfuscator{
                opacity:1;
                transition: all 600ms;
            }

            .login-popup{
               // top:50%;

                @media (max-width: 767px) {
                    position: relative;
                    margin:0 auto;
                    margin-top:30px;
                    margin-bottom:30px;
                    top: 50%;
                    transform: translateY(-50%);
                }

                @media (max-width: 575px) {
                    margin-top:30px;
                }

                margin-top:30px;
                margin-bottom:30px;
                opacity: 1;
                transition: opacity 600ms;
                transition-delay: 400ms;



            }

        }

        .login-popup{
            position: absolute;
           /* top:55%;
            left:50%;
            transform: translate(-50%, -50%);*/
            margin-top:20px;
            width: 90%;
            height:auto;
            display: flex;
            background: #ffffff;
            //padding:20px;
            opacity:0;
            /*max-height: calc(100vh - 30px);
            overflow-y: scroll;*/

            .product-line{
                max-width: 100%;
            }

            .all-list{
                margin-bottom:0px;
            }

            .owl-dots{
                display: flex !important;
                align-items: center;
                justify-content: center;
                margin-top:30px;

                @media(max-width: 575px) {
                    margin-top:10px;
                }

                .owl-dot{
                    border:1px solid transparent;
                    margin: 5px 12px;
                    padding:0px 3px;

                    span{
                        width: 8px;
                        height: 8px;
                        box-shadow:0px 0px 0px 1px rgba(255, 255, 255, 0.2);
                        background:transparent;
                        margin:0;
                    }

                    &.active{
                        border:1px solid rgba(255, 255, 255, 0.2);
                        box-shadow:0px 0px 0px 3px rgba(255, 255, 255, 0.05);
                        padding: 4px 4px !important;
                        border-radius: 25px;

                        span{
                            width: 10px;
                            height: 10px;
                            background:#c0a680;
                            border-color:#c0a680;
                        }

                    }

                }

            }

            padding:0px;

            .semi-block{
                padding: 25px;
            }

            @media(min-width: 992px) {
                padding:0px;

                .semi-block{
                    padding: 30px 25px;
                }

            }

            @media(min-width: 1200px) {
                padding:0px;

                .semi-block{
                    padding: 40px 35px;
                }

            }

            .form-submit{
                margin-top:0px;
                width: 100%;

                a{
                    width: 100%;
                    padding: 17px 25px 16px;
                    display: flex;
                    justify-content: center;
                }

            }

        }

        .background-obfuscator{
            position:fixed;
            left:0px;
            top:0;
            width: calc(100%);
            height:100%;
            background:rgba(0, 0, 0, 0.7);
            z-index:-1;
            opacity: 0;
            transition: all 600ms;
        }

        .p-img{
            position: relative;
            max-width: 90px;
            object-fit: contain;

            @media (max-width: 575px){
                max-width: 65px;
            }

        }

        .other-products-text{

            @media (max-width:575px){
                font-size: 1.2rem;
                margin-bottom:0px;
            }

        }

        .close-preview{
            position:absolute;
            right:20px;
            top:20px;
            width:30px;
            height:30px;
            display:flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 100;

            @media (max-width: 575px) {
                right: 15px;
                top: 15px;
            }

            img{
                transform: rotate(0deg);
                transition: all 500ms ease-in-out;
            }

            &:before, &:after{
                display: none;
            }

            &:hover{

                img{
                    transform: rotate(360deg);
                    transition: all 500ms ease-in-out;
                    transition-delay: 50ms;

                }
            }

        }

        .popup-text{
            font-style: italic;
            font-size:1.25rem;

            @media(max-width: 575px) {
                font-size:1rem;
            }

            span{
                white-space: initial;
            }
        }

        .product-text{
            font-size:1.1rem;

            @media(max-width: 575px) {
                font-size:.9rem;
            }

            & > span{
                white-space: initial;
            }

        }

        .prodotto-price{
            font-size:1.25rem;

            span{
                font-size: 13px;
                margin-right: 1px;
                display: inline-block;
                position: relative;
                top: -8px;
            }

        }

        .bg-beige{
            background: #f1ece5 !important;
        }

        .max-w-register{
            max-width:550px;

            @media (min-width:992px) {
                max-width:870px;
            }
        }

        .max-w-login{
            max-width:450px;
        }

        .register-perks{

            .plus{

                img{
                    width:26px;
                    height:26px;
                }

            }

        }

    }

</style>

<template>
    <div id="popup-container" :class="{'appear' : show}">
        <div class="background-obfuscator" @click="closePopup"></div>

        <div class="login-popup" :class="session == 'register' ? 'max-w-register' : 'max-w-login'">
            <div class="close-preview" @click="closePopup">
                <a href="javascript:void(0)">
                    <img width="25" src="/images/svg/as-1.svg" alt="icona" />
                </a>
            </div>
            <div class="col-12" v-if="session == 'register'">
                <div class="row">
                    <div class="col-12 col-lg-6 semi-block d-flex flex-column">
                        <div class="all-list">
                            <h4 class="simple-text text-center w-100 mb-4">{{$root.translateString('register')}}</h4>
                        </div>

                        <div class="flex-grow-1">

                            <div class="full-input mb-4 pb-1">
                                <div class="full-input__field-gr">
                                    <input
                                        name="register-name"
                                        type="text"
                                        placeholder=" "
                                        data-lpignore="true"
                                        @focus="validation.name.state = null"
                                        @keyup.enter="register"
                                        v-model="user.name">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.name.state == false}">{{validation.name.message}}</div>
                                    <label class="full-input__after-input">
                                        {{$root.translateString('name')}}
                                    </label>
                                </div>
                            </div>

                            <div class="full-input mb-4 pb-1">
                                <div class="full-input__field-gr">
                                    <input
                                        name="register-email"
                                        type="email"
                                        data-lpignore="true"
                                        placeholder=" "
                                        @focus="validation.email.state = null"
                                        @keyup.enter="register"
                                        v-model="user.email">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.email.state == false}">{{validation.email.message}}</div>
                                    <label class="full-input__after-input">
                                        Email
                                    </label>
                                </div>
                            </div>

                            <div class="full-input mb-4 pb-1">
                                <div class="full-input__field-gr">
                                    <input
                                        name="register-password"
                                        type="password"
                                        data-lpignore="true"
                                        placeholder=" "
                                        @focus="validation.password.state = null"
                                        @keyup.enter="register"
                                        v-model="user.password">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.password.state == false}">{{validation.password.message}}</div>
                                    <label class="full-input__after-input">
                                        Password
                                    </label>
                                </div>
                            </div>

                            <div class="w-100 mt-4 mb-4">
                                <div class="checkbox-styles">
                                    <div class="checkbox">
                                        <input type="checkbox" id="privacy" class="cb" name="privacy" @change="validation.privacy.state = null" v-model="privacy">
                                        <label for="privacy"></label>
                                    </div>
                                    <div class="checkbox-styles__link checkbox-link-js checkout" @click="privacy = !privacy">
                                        <span>{{$root.translateString('acceptance')}} &nbsp;<a :href="'/' + lang + '/privacy-policy'">{{$root.translateString('acceptance_link')}}</a></span>
                                    </div>
                                </div>
                                <div class="invalid-feedback privacy pt-1" :class="{'d-block' : validation.privacy.state == false}">{{validation.privacy.message}}</div>
                            </div>

                        </div>

                        <div class="w-100">
                            <div class="brand-btn">
                                <a class="full py-2 w-100 text-center" href="javascript:void(0)" @click="register">
                                <span class="my-1">
                                     {{$root.translateString('register-now')}}
                                </span>
                                </a>
                            </div>
                        </div>
                        <div class="w-100 text-center pt-3">
                            <p class="mb-0 d-inline-flex simple-text">
                                {{$root.translateString('have-an-account')}}
                                <a class="text-link text-link--gold ml-2" href="javascript:void(0)" @click="toggleType('login')">
                                    <span>{{$root.translateString('login-now')}}</span>
                                </a>
                            </p>
                        </div>

                    </div>
                    <div class="col-12 col-lg-6 bg-beige semi-block">
                        <div class="max-w-500 w-100 register-perks">
                            <h3 class="azienda-gold-title azienda-gold-title--auth-small pb-2 mb-2 mb-sm-3 mb-lg-3 pr-lg-4">
                                {{$root.translateString('perks-title-short') }}
                            </h3>
                            <p class="simple-text mb-3 mb-sm-3 pb-2">{{$root.translateString('perks-subtitle') }}</p>
                            <div class="w-100">
                                <div class="plus d-flex mb-2 mb-sm-3 pb-lg-2 align-items-center pb-1 pb-sm-0">
                                    <img class="mr-3" alt="icona" width="30" src="/images/area-utente/icon-06.svg"/>
                                    <div class="text flex-xl-grow-1">
                                        <p class="simple-text mb-0">{{$root.translateString('perks-first')}}</p>
                                    </div>
                                </div>
                                <div class="plus d-flex mb-2 mb-sm-3 pb-lg-2 align-items-center pb-1 pb-sm-0">
                                    <img class="mr-3" alt="icona" width="30" src="/images/area-utente/icon-06.svg"/>
                                    <div class="text flex-xl-grow-1">
                                        <p class="simple-text mb-0">{{$root.translateString('perks-second')}}</p>
                                    </div>
                                </div>
                                <div class="plus d-flex mb-2 mb-sm-3 pb-lg-2 align-items-center pb-1 pb-sm-0">
                                    <img class="mr-3" alt="icona" width="30" src="/images/area-utente/icon-06.svg"/>
                                    <div class="text flex-xl-grow-1">
                                        <p class="simple-text mb-0">{{$root.translateString('perks-third')}}</p>
                                    </div>
                                </div>
                                <div class="plus d-flex mb-2 mb-sm-3 pb-lg-2 align-items-center pb-1 pb-sm-0">
                                    <img class="mr-3" alt="icona" width="30" src="/images/area-utente/icon-06.svg"/>
                                    <div class="text flex-xl-grow-1">
                                        <p class="simple-text mb-0">{{$root.translateString('perks-fourth')}}</p>
                                    </div>
                                </div>
                                <div class="plus d-flex mb-0 pb-2 pb-lg-2 align-items-center">
                                    <img class="mr-3" alt="icona" width="30" src="/images/area-utente/icon-06.svg"/>
                                    <div class="text flex-xl-grow-1">
                                        <p class="simple-text mb-0">{{$root.translateString('perks-fifth')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 semi-block" v-else>
                <div class="row">
                    <div class="col-12 mb-2">
                        <div class="">
                            <h4 class="simple-text text-center w-100 mb-4">{{$root.translateString('login-long')}}</h4>
                        </div>
                        <div class="">

                            <div class="full-input mb-4 pb-1">
                                <div class="full-input__field-gr">
                                    <input
                                        name="login-name"
                                        type="email"
                                        placeholder=" "
                                        @focus="validation.email.state = null"
                                        @keyup.enter="login"
                                        v-model="user.email">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.email.state == false}">{{validation.email.message}}</div>
                                    <label class="full-input__after-input">
                                        Email
                                    </label>
                                </div>
                            </div>

                            <div class="full-input mb-4">
                                <div class="full-input__field-gr">
                                    <input
                                        name="login-password"
                                        type="password"
                                        placeholder=" "
                                        @focus="validation.password.state = null"
                                        @keyup.enter="login"
                                        v-model="user.password">
                                    <div class="invalid-feedback" :class="{'d-block' : validation.password.state == false}">{{validation.password.message}}</div>
                                    <label class="full-input__after-input">
                                        Password
                                    </label>
                                </div>
                            </div>

                            <div class="form-agree d-inline-block mb-0 pb-2">
                                <p class="torna-prodotti-link text-gold text-smaller-90 mb-0 d-inline-flex">
                                    <a class="ml-0 text-link" :href="lang == 'it' ? '/password/reset' : '/en/password/reset'">
                                        <span>{{$root.translateString('forgot-password')}}</span>
                                    </a>
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-2">
                        <div class="brand-btn">
                            <a class="full py-2 w-100 text-center" href="javascript:void(0)" @click="login">
                                <span class="my-1">
                                     {{$root.translateString('login')}}
                                </span>
                            </a>
                        </div>
                    </div>
                    <div class="col-12 text-center pt-3" v-if="!hide_register">
                        <p class="mb-0 d-inline-flex simple-text">
                            {{$root.translateString('dont-have-an-account')}}
                            <a class="text-link text-link--gold ml-2" href="javascript:void(0)" @click="toggleType('register')">
                                <span>{{$root.translateString('register-now')}}</span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div class="loader-checkout d-flex align-items-center justify-content-center" v-if="loading">
                <img width="40" src="/images/loader.svg" alt="loader"/>
            </div>
        </transition>

    </div>
</template>
<script>

export default {

    // @todo da aggiornare marketing_acceptance se il componente verrà usato

    props: ['lang'],
    data() {
        return {
            session: 'register',
            show: false,
            privacy: false,
            loading: false,
            hide_register: false,
            user: {
                name: '',
                email: '',
                password: '',
            },
            validation: {
                name: {
                    state: null,
                    message: '',
                },
                email: {
                    state: null,
                    message: '',
                },
                password: {
                    state: null,
                    message: '',
                },
                privacy: {
                    state: null,
                    message: '',
                }
            }
        }
    },
    mounted() {
        this.$eventHub.$on('login', payload => {
            if(typeof payload.hide_register != 'undefined') {
                this.hide_register = payload.hide_register;
            }
            this.session = 'login';
            this.openPopup();
        });
        this.$eventHub.$on('register', () => {
            this.session = 'register';
            this.openPopup();
        });
    },
    methods: {
        cantProceed() {
            let error = false;

            if(this.session == 'register') {

                if (typeof this.user.name == 'undefined' || this.user.name == '') {
                    if(this.lang == 'it') {
                        this.validation.name.message = 'Questo campo non può essere vuoto.';
                    }else{
                        this.validation.name.message = 'This field cannot be empty.';
                    }
                    this.validation.name.state = false;
                    error = true;
                } else {
                    this.validation.name.state = null;
                }

                if (typeof this.user.password == 'undefined' || this.user.password == '') {
                    if(this.lang == 'it') {
                        this.validation.name.message = 'Questo campo non può essere vuoto.';
                    }else{
                        this.validation.name.message = 'This field cannot be empty.';
                    }
                    this.validation.password.state = false;
                    error = true;
                } else {
                    this.validation.password.state = null;
                }

                if (typeof this.privacy == 'undefined' || this.privacy != true) {
                    if(this.lang == 'it') {
                        this.validation.privacy.message = 'Devi leggere e accettare le condizioni.';
                    }else{
                        this.validation.privacy.message = 'You have to read and accept the privacy policy.';
                    }
                    this.validation.privacy.state = false;
                    error = true;
                } else {
                    this.validation.privacy.state = null;
                }

                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let disposable = require('is-disposable-email');
                if (! re.test(this.user.email)) {
                    if(this.lang == 'it') {
                        this.validation.email.message = 'Non sembra un indirizzo email valido.';
                    }else{
                        this.validation.email.message = 'The email address is invalid.';
                    }
                    this.validation.email.state = false;
                    error = true;
                } else {
                    if (disposable(this.user.email)) {
                        if(this.lang == 'it') {
                            this.validation.email.message = 'Tipologia di servizio email non valido.';
                        }else{
                            this.validation.email.message = 'You email provider is invalid.';
                        }
                        this.validation.email.state = false;
                        error = true;
                    } else {
                        this.validation.email.state = null;
                    }
                }

                return error;

            }else{

                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (! re.test(this.user.email)) {
                    if(this.lang == 'it') {
                        this.validation.email.message = 'Non sembra un indirizzo email valido.';
                    }else{
                        this.validation.email.message = 'Your email is invalid.';
                    }
                    this.validation.email.state = false;
                    error = true;
                } else {
                    this.validation.email.state = null;
                }

                if (typeof this.user.password == 'undefined' || this.user.password == '') {
                    if(this.lang == 'it') {
                        this.validation.password.message = 'Questo campo non può essere vuoto.';
                    }else{
                        this.validation.password.message = 'This field cannot be empty.';
                    }
                    this.validation.password.state = false;
                    error = true;
                    this.loading = false;
                } else {
                    this.validation.password.state = null;
                }

                return error;

            }

        },
        register() {

            if(this.loading) {
                return false;
            }else{
                this.loading = true;
            }

            if(!this.cantProceed()) {

                let payload = this.user;

                // send post request
                axios.post('/register', {
                    name: this.user.name,
                    email: this.user.email,
                    password: this.user.password,
                    url: window.location.href,
                })
                    .then((response) => {

                    if (response.data.redirect != undefined) {
                        setTimeout(function () {
                            window.location.href = response.data.redirect;
                        }, 1000);
                    } else {

                        this.closePopup();

                        let message = '';

                        if(this.lang == 'it') {
                            message = 'Staimo creando il tuo account...';
                        }else{
                            message = 'We are creating your account...';
                        }

                        this.loading = false;
                        this.$eventHub.$emit('notification', {
                            type: 'success',
                            message: message,
                            time: 10
                        });

                        setTimeout(function () {
                            window.location.reload();
                        }, 2000);

                    }

                })
                    .catch( e =>  {
                        let errors = e.response.data.errors;
                        this.loading = false;

                        // handle errors
                        for (let error in errors) {
                            this.validation[error].message = errors[error][0];
                            this.validation[error].state = false;
                        }
                    });
            }else{
                this.loading = false;
            }

        },
        login() {

            if(this.loading) {
                return false;
            }else{
                this.loading = true;
            }

            if(!this.cantProceed()) {

                this.loading = true;

                axios.post('/login', {
                    email: this.user.email,
                    password: this.user.password,
                })
                    .then((response) => {

                        let message = '';

                        if(this.lang == 'it') {
                            message = 'Accesso eseguito con successo!';
                        }else{
                            message = 'You signed in successfully!';
                        }

                        this.loading = false;
                        this.$eventHub.$emit('notification', {
                            type: 'success',
                            message: message,
                            time: 10
                        });

                        setTimeout(() => {
                            window.location.reload();
                        }, 1000)

                        window.location.reload();
                    })
                    .catch( e =>  {
                        let errors = e.response.data.errors;
                        this.loading = false;

                        // handle errors
                        for (let error in errors) {
                            this.validation[error].message = errors[error][0];
                            this.validation[error].state = false;
                        }
                    });
            }else{
                this.loading = false;
            }
        },
        toggleType(type) {
            if(this.session == type) return;
            this.session = type;
            this.validation.privacy.state = null;
            this.validation.privacy.message = '';
            Object.keys(this.validation).forEach((elem, key) => {
                this.validation[elem].message = '';
                this.validation[elem].state = null;
            });
        },
        openPopup() {
            this.show = true;
            document.body.style.top = `-${window.scrollY}px`;
            document.body.style.position = '';
            document.body.style.overflowY = 'scroll';
            $('body').toggleClass('menu-open');
        },
        closePopup() {
            this.show = false;
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.overflowY = '';
            $('body').toggleClass('menu-open');
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        },
    },
    beforeDestroy() {
        this.$eventHub.$off('login');
    },
    computed: {
    }
}
</script>
